import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, withDefaults } from 'vue';
import type VueI18n from 'vue-i18n/types';
interface Step {
  id?: string | number;
  label: string | VueI18n.TranslateResult;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'progression-stepper',
  props: {
    steps: { default: () => [] },
    value: { default: 0 }
  },
  emits: ["input", "update:value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input' | 'update:value', val: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { steps: Step[], value: number };

const IconCheck = () => import('@white-label-icon/icon-check');






const activeStep = ref(props.value ?? 0);

watch(() => props.value, (val) => {
  if (typeof val === 'number') activeStep.value = val;
});

function setActiveStep(idx: number) {
  if (idx !== activeStep.value) {
    activeStep.value = idx;
    emit('input', idx);
  }
}


return { __sfc: true,IconCheck, props, emit, activeStep, setActiveStep }
}

})